import { routesApi } from "../../api";

const RoutesService = {
  /**
   * 🔹 Buscar rutas accesibles según el texto ingresado (qry)
   * @param qry Texto de búsqueda parcial (ej: "venta", "compra", "inventario")
   */
  searchAccessibleRoutes: async (qry: string) => {
    const response = await routesApi.fetchCustom(`/search?qry=${encodeURIComponent(qry)}`);
    return response.data;
  },
};

export default RoutesService;
